import { sysaidAccountId } from './common';

const BASE_PATH = '/spaces';
// NOTE: This enum must contain all route paths that should display the NavBar.
// See the getShowNavBar function in src/common/utils/utils.js.
// It is REQUIRED to prevent the error: `Objects are not valid as a React child (found: object with keys {children})`, which occurs when wrapping some components in LoggedInRoutesPanel.
// TODO: Remove this enum and use the route paths directly in the code.
enum Page {
  HOME = '',
  LOGOUT = 'logout',
  TICKET = 'ticket',
  TEMPLATES_LIST = 'templates-list',
  SETTINGS = 'settings',
  CLASSIC = 'classic',
  CONNECT = 'connect',
  INTEGRATIONS = 'integrations',
  EXTERNAL_CLASSIC = 'external/classic',
  EXTERNAL_INTEGRATIONS = 'external/integrations',
  LICENSE_MANAGER = 'license-manager',
  LICENSE_MANAGER_DISCOVERY = 'license-manager/discovery',
  TRIAL = 'trial',
  TEMPLATE = 'template',
}

export const FORGOT_PASSWORD_SUBDIRECTORY = 'forgot-password';
export const LOGIN_SUBDIRECTORY = 'login';
export const CHECK_MAIL_SUBDIRECTORY = 'check-mail';
export const ROUTES_PATHS = {
  BASE_PATH,
  QUEUE: `${BASE_PATH}/`,
  LOGIN_URL: `${BASE_PATH}/${LOGIN_SUBDIRECTORY}`,
  LOGOUT_URL: `${BASE_PATH}/${Page.LOGOUT}`,
  TEMPLATE_URL: `${BASE_PATH}/${Page.TEMPLATE}`,
  TEMPLATE_LIST_URL: `${BASE_PATH}/${Page.TEMPLATES_LIST}`,
  SETTINGS_URL: `${BASE_PATH}/${Page.SETTINGS}`,
  TICKET_URL: `${BASE_PATH}/${Page.TICKET}`,
  FORGOT_PASSWORD_URL: `${BASE_PATH}/${FORGOT_PASSWORD_SUBDIRECTORY}`,
  CHECKMAIL_URL: `${BASE_PATH}/check-mail`,
  CLASSIC_PAGE_URL: `${BASE_PATH}/${Page.CLASSIC}`,
  PAGE404_URL: `${BASE_PATH}/404`,
  _URL: `${BASE_PATH}/template`,
  SERVICE_PORTAL_URL: '/servicePortal',
  WORKFLOW_DESIGNER: '/workflowDesigner',
  KEEP_ALIVE: '/KeepAlive.jsp',
  PREFERENCES: '/Preferences.jsp',
  CONNECT: `${BASE_PATH}/${Page.CONNECT}`,
  INTEGRATIONS: `${BASE_PATH}/${Page.INTEGRATIONS}`,
  EXTERNAL_CLASSIC: `${BASE_PATH}/${Page.EXTERNAL_CLASSIC}`,
  EXTERNAL_INTEGRATIONS: `${BASE_PATH}/${Page.EXTERNAL_INTEGRATIONS}`,
  LICENSE_MANAGER: `${BASE_PATH}/${Page.LICENSE_MANAGER}`,
  TRIAL: `${BASE_PATH}/${Page.TRIAL}`,
};

export const PAGES_LIST = Object.values(Page);

export const EXTERNAL_LINKS = {
  AI_USAGE_DASHBOARD: `https://sysaid-${sysaidAccountId}.eu.qlikcloud.com/sense/app/6e1cfa8a-ea92-4497-8638-14f539c3ab27/sheet/JfdRFGV/state/analysis`,
};
